module.exports = __webpack_public_path__ + "img/401.95c7af15.svg";